import { render, staticRenderFns } from "./WaterQualityChart.vue?vue&type=template&id=2fd236d2&scoped=true"
import script from "./WaterQualityChart.vue?vue&type=script&lang=js"
export * from "./WaterQualityChart.vue?vue&type=script&lang=js"
import style0 from "./WaterQualityChart.vue?vue&type=style&index=0&id=2fd236d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd236d2",
  null
  
)

export default component.exports